import React, { FunctionComponent } from 'react';
import { getBackgroundURL } from '../../common/helpers/backgroundHelper';
import styles from './styles.module.scss';

interface IProps {
  logo: string;
  circleColor: string;
}

const CandidateFormSidebar: FunctionComponent<IProps> = ({ children, circleColor, logo }) => (
  <div className={styles.background} style={{ backgroundImage: getBackgroundURL(circleColor) }}>
    {logo && <img className={styles.logo} src={logo} alt="" />}
    {children}
  </div>
);

export default CandidateFormSidebar;
